import React, { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { AdaptiveLogo } from '../components/ui/AdaptiveLogo';

export const Auth = ({ setUsername }) => {
    const { loginWithRedirect, isAuthenticated, getAccessTokenSilently, isLoading } = useAuth0();
    const { authenticate, name, refreshAuthState } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (isAuthenticated) navigate("/catalogue");
    }, [isAuthenticated]);

    useEffect(() => {
        const authenticateUser = async () => {
            if (!isAuthenticated) return;

            try {
                const accessToken = await getAccessTokenSilently();

                if (!accessToken) {
                    return;
                }

                const success = await authenticate(accessToken);

                if (success) {
                    refreshAuthState();

                    if (name) {
                        setUsername(name);
                    }

                    navigate("/catalogue");
                }

            } catch (error) {
                // Silent error handling
            }
        };

        authenticateUser();
    }, [isAuthenticated, getAccessTokenSilently, authenticate, name, setUsername, navigate]);

    return (
        <div className="flex items-center flex-col gap-6 justify-center text-card-foreground h-full">
            <AdaptiveLogo width={ 64 } height={ 64 } />
            <h1 className="text-muted-foreground text-2xl">Welcome to Delphos Copilot</h1>

            { isLoading ? (
                <div className="flex items-center justify-center">
                    <div className="w-8 h-8 border-4 border-muted border-t-primary rounded-full animate-spin"></div>
                </div>
            ) : (
                <div className="flex flex-col max-w-[200px] gap-4">
                    <button
                        onClick={ () => loginWithRedirect() }
                        className="btn-primary text-lg"
                    >
                        Sign In
                    </button>

                    <button
                        onClick={ () =>
                            loginWithRedirect({
                                authorizationParams: {
                                    screen_hint: "signup",
                                },
                            })
                        }
                        className="text-muted-foreground text-xs hover:text-card-foreground transition-colors"
                    >
                        Don't have an account? Sign up
                    </button>

                </div>
            ) }
        </div>
    );
};
